var O = Object.defineProperty;
var I = (n, e, t) => e in n ? O(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var E = (n, e, t) => (I(n, typeof e != "symbol" ? e + "" : e, t), t);
const P = () => "PikPak_JS_BRIDGE_xxxxxxxxxxxxxxxxxxxxxxxx".replace(/[xy]/g, function(e) {
  var t = Math.random() * 16 | 0, r = e === "x" ? t : t & 3 | 8;
  return r.toString(16);
}), T = () => {
  var n = navigator.userAgent.toLowerCase();
  return /android/.test(n) ? "Android" : /iphone|ipad|ipod/.test(n) ? "IOS" : "PC";
}, U = () => /pikpak/i.test(navigator.userAgent), p = () => ({
  name: P(),
  fn: (n) => new Promise((e, t) => {
    var r;
    try {
      const a = JSON.parse(n);
      return ((r = a == null ? void 0 : a.internalError) == null ? void 0 : r.errorCode) === 1 ? t({ code: 404, description: "method is not declared" }) : e(a);
    } catch {
      return t({ code: -2, description: "process response data error!" });
    }
  })
}), C = () => ({
  name: P(),
  fn: (n, e) => new Promise((t, r) => {
    try {
      if (n)
        return n.code === -999 ? r({ code: 404, description: "method is not declared" }) : r(n);
      {
        const a = (e == null ? void 0 : e.result) || {};
        return t(a);
      }
    } catch {
      return r({ code: -2, description: "process response data error!" });
    }
  })
}), B = (n) => ["ppRequest", "ppGetFileData", "ppFetchFileMetaData", "ppUpdateConnectivity"].includes(n) ? 3e5 : 1e4, m = (n, e) => {
  const t = window.PikPakJSBridge;
  return new Promise((r, a) => {
    const c = B(n);
    if (T() === "Android") {
      const { name: i, fn: s } = p();
      window[i] = async (o) => {
        try {
          clearTimeout(l);
          const d = await s(o);
          return r(d);
        } catch (d) {
          return a(d);
        }
      };
      const l = setTimeout(() => (window[i] = async () => {
      }, a({ code: -1e3, description: "native response timeout" })), c);
      t.sendMessage(n, JSON.stringify(e), i);
    } else {
      if (!t)
        return a({ code: 404, description: "method is not declared" });
      const { fn: i } = C();
      let s = async (o, d) => {
        try {
          clearTimeout(l);
          const u = await i(o, d);
          return r(u);
        } catch (u) {
          return a(u);
        }
      };
      const l = setTimeout(() => (s = async () => {
      }, a({ code: -1e3, description: "native response timeout" })), c);
      t.sendMessage(n, e, s);
    }
  });
};
class z {
  constructor(e) {
    E(this, "win");
    this.win = (e == null ? void 0 : e.window) || window;
  }
  isTopWindow() {
    return this.win === window;
  }
  sendMessage(e, t) {
    return new Promise((r, a) => {
      try {
        const c = B(e), { port1: i, port2: s } = new MessageChannel();
        s.onmessage = (o) => {
          var d, u, g;
          if (((d = o.data) == null ? void 0 : d.type) === "RESPONSE_BRIDGE_MESSAGE")
            return clearTimeout(l), o.data.success ? r(((u = o.data) == null ? void 0 : u.result) || {}) : a(((g = o.data) == null ? void 0 : g.result) || { code: -999 });
        };
        const l = setTimeout(() => (s.onmessage = () => {
        }, a({ code: -1e3, description: "native response timeout" })), c);
        this.win.postMessage({ type: "REQUEST_BRIDGE_MESSAGE", apiName: e, params: t }, "*", [i]);
      } catch (c) {
        return a(c);
      }
    });
  }
  async request(e, t) {
    return this.isTopWindow() ? m(e, t) : this.sendMessage(e, t);
  }
}
const y = class y {
  constructor() {
  }
  static serve() {
    var e;
    if (!window.PikPakJSBridge)
      throw new Error("window.PikPakJSBridge not exist, bridge proxy start failed!");
    y.lastController && (y.lastController.abort(), y.lastController = void 0), y.lastController = new AbortController(), window.addEventListener("message", (t) => {
      var r;
      try {
        if (((r = t.data) == null ? void 0 : r.type) === "REQUEST_BRIDGE_MESSAGE") {
          const { apiName: a, params: c } = t.data;
          let i = !0, s = {};
          if (T() === "Android" && U()) {
            const { fn: l } = p();
            window[a] = async (o) => {
              var d;
              try {
                s = await l(o);
              } catch (u) {
                i = !1, s = { code: u.code, description: u.description };
              }
              (d = t.ports[0]) == null || d.postMessage({ type: "RESPONSE_BRIDGE_MESSAGE", success: i, result: s });
            }, window.PikPakJSBridge.sendMessage(a, JSON.stringify(c), a);
          } else {
            const { fn: l } = C(), o = async (d, u) => {
              var g;
              try {
                s = await l(d, u);
              } catch (h) {
                i = !1, s = { code: h.code, description: h.description };
              }
              (g = t.ports[0]) == null || g.postMessage({ type: "RESPONSE_BRIDGE_MESSAGE", success: i, result: s });
            };
            window.PikPakJSBridge.sendMessage(a, c, o);
          }
        }
      } catch (a) {
        console.error("bridge proxy serve error: ", a);
      }
    }, {
      signal: (e = y.lastController) == null ? void 0 : e.signal
    });
  }
};
E(y, "lastController");
let R = y;
const b = async (n, e) => {
  var d, u, g, h;
  const t = (e == null ? void 0 : e.parallelNumber) || 2, r = (e == null ? void 0 : e.unitChunkSize) || 1 * 1024 * 1024, a = 500 * 1024 * 1024, c = ((u = (d = e == null ? void 0 : e.bridgeClient) == null ? void 0 : d.request) == null ? void 0 : u.bind(e.bridgeClient)) || m, i = new Array(t).fill(0).map((w, f) => c("ppGetFileData", {
    fileId: n,
    startByte: f * r,
    sizeByte: r,
    autoDownload: !0
  }));
  let s = await Promise.all(i);
  if (s[0].fileSize >= a)
    throw new Error(
      "MAX_SIZE_LIMIT"
      /* MAX_SIZE_LIMIT */
    );
  if (s[0].downloadStatus === "STATUS_FAILED")
    throw new Error(
      "DOWNLOAD_ERROR"
      /* DOWNLOAD_ERROR */
    );
  if (s[0].downloadStatus === "STATUS_RUNNING") {
    const w = Number(Math.abs(s[0].downloadedSize / s[0].fileSize).toFixed(4));
    return (g = e == null ? void 0 : e.progress) == null || g.call(e, w), await new Promise((f) => {
      let S = setTimeout(() => {
        f(b(n, e)), clearTimeout(S);
      }, 200);
    });
  }
  if ((h = e == null ? void 0 : e.progress) == null || h.call(e, 1), Math.max(s[0].fileSize - t * r, 0) > 0) {
    const w = Math.ceil((s[0].fileSize - t * r) / (r * t));
    for (let f = 0; f < w; f++) {
      const S = await Promise.all(new Array(t).fill(0).map((A, D) => {
        var x;
        return (((x = e == null ? void 0 : e.bridgeClient) == null ? void 0 : x.request) || m)("ppGetFileData", {
          fileId: n,
          startByte: ((f + 1) * t + D) * r,
          sizeByte: r,
          autoDownload: !0
        });
      }));
      s = s.concat(S.filter(({ sizeByte: A }) => A > 0));
    }
  }
  s.sort((w, f) => w.startByte > f.startByte ? 1 : -1);
  const o = s.filter(({ sizeByte: w }) => w > 0).map(({ fileData: w }) => w);
  if (o.length === 0)
    throw new Error(
      "DOWNLOAD_ERROR"
      /* DOWNLOAD_ERROR */
    );
  return o;
}, M = (n) => {
  const e = n.reduce((a, c) => a + c.length, 0), t = new Uint8Array(e);
  let r = 0;
  return n.forEach((a) => {
    t.set(a, r), r += a.length;
  }), t;
}, _ = (n) => n.map((e) => {
  const t = atob(e), r = new Array(t.length);
  for (let c = 0; c < t.length; c++)
    r[c] = t.charCodeAt(c);
  return new Uint8Array(r);
}), G = (n, e = "text/plain;") => {
  const t = _(n), a = M(t).buffer, c = new Blob([a], { type: e });
  return URL.createObjectURL(c);
}, F = async (n, e) => {
  if (window !== window.top)
    throw new Error("暂不支持在iframe内调用此方法");
  const t = await b(n, e), r = (e == null ? void 0 : e.mimeType) || "text/plain;";
  return G(t, r);
}, q = async (n, e) => {
  if (window !== window.top)
    throw new Error("暂不支持在iframe内调用此方法");
  const t = await b(n, e), r = _(t);
  return M(r).buffer;
}, k = (n) => ({
  value: n,
  __v_isRef: !0
}), N = (n) => !!(n && typeof n == "object" && !Array.isArray(n) && n.error_description), v = (n, e, t) => {
  const r = {
    data: k(null),
    error: k(null)
  };
  e = JSON.parse(JSON.stringify(e));
  const c = (async () => {
    try {
      const i = {
        url: n,
        method: e.method || "GET",
        headers: e.headers,
        body: e.body,
        withCredential: e.withCredentials
      }, s = t ? await t("ppRequest", i) : await m("ppRequest", i), { errorKey: l, errorDescription: o, response: d } = s;
      return l || o ? (r.error.value = { message: o, error: l }, r) : (r.data.value = d, r);
    } catch (i) {
      console.error("request error: ", i), r.error.value = N(i) ? { ...i, message: i.error_description } : i;
    }
    return r;
  })();
  return {
    ...r,
    then(i) {
      return c.then(i);
    }
  };
}, W = (n) => new Promise((e) => {
  let t = -1;
  try {
    if (!/PikPak/i.test(window.navigator.userAgent))
      return e(!1);
    t = setTimeout(() => {
      e(!0), t && clearTimeout(t);
    }, 100), m(n, {}).then(() => e(!0)).catch((r) => e((r == null ? void 0 : r.code) && r.code !== 404));
  } catch (r) {
    return e((r == null ? void 0 : r.code) && r.code !== 404);
  }
}), Q = (n = "stun:8.219.220.18:3478") => new Promise((e) => {
  try {
    typeof window.RTCPeerConnection > "u" && e(""), setTimeout(() => e(""), 2e3);
    const t = /([a-f0-9]{1,4}(:[a-f0-9]{1,4}){7}) 8888/, r = new RTCPeerConnection({
      iceServers: [{ urls: n }]
    });
    r.onicecandidate = (a) => {
      if (a.candidate) {
        const c = t.exec(a.candidate.candidate);
        if (c !== null && c.length > 1) {
          const i = c[1];
          e(i);
        }
      }
    }, r.createDataChannel("detect"), r.createOffer().then((a) => {
      r.setLocalDescription(a);
    });
  } catch (t) {
    return console.error("get real ip error: ", t), e("");
  }
});
export {
  z as BridgeClient,
  R as BridgeProxy,
  m as default,
  W as detectBridgeIsExists,
  q as getFileBufferById,
  F as getFileObjectURLById,
  Q as getRealIpToken,
  v as useBridgeFetch
};
